import React from 'react'

export default function About() {
  return (
    <div className="bg-black text-white min-h-screen py-12 px-4">
      <div className="max-w-7xl mx-auto space-y-12">
        <header className="space-y-4">
          <h1 className="text-4xl font-extrabold">About Bristu English Learning App</h1>
          <p className="text-lg text-gray-300">
            Bristu is a comprehensive English learning platform designed to help learners master the English language through interactive courses, personalized learning experiences, and seamless payment integration for a smooth educational journey.
          </p>
        </header>

        <section className="space-y-10">
          {[
            {
              title: 'Our Mission',
              content: (
                <p className="text-gray-300">
                  At Bristu, our mission is to make English learning accessible, engaging, and effective for learners worldwide. We combine cutting-edge technology with proven language learning methodologies to create an immersive educational experience that helps students achieve fluency in English.
                </p>
              )
            },
            {
              title: 'What We Offer',
              content: (
                <div className="space-y-4 text-gray-300">
                  <ul className="list-disc list-inside space-y-2">
                    <li><span className="font-semibold text-white">Interactive English Courses:</span> Comprehensive lessons covering grammar, vocabulary, pronunciation, and conversation skills.</li>
                    <li><span className="font-semibold text-white">AI-Powered Learning:</span> Personalized learning paths that adapt to your English proficiency level and learning style.</li>
                    <li><span className="font-semibold text-white">Native Speaker Content:</span> Authentic English content from certified native speakers and language experts.</li>
                    <li><span className="font-semibold text-white">Practice Exercises:</span> Interactive quizzes, speaking exercises, and writing assignments to reinforce learning.</li>
                    <li><span className="font-semibold text-white">Progress Tracking:</span> Detailed analytics to monitor your English learning journey and achievements.</li>
                    <li><span className="font-semibold text-white">Audio & Video Lessons:</span> Multimedia content for comprehensive language acquisition.</li>
                  </ul>
                  <div className="mt-4 p-4 bg-gray-800 rounded-lg">
                    <p className="font-semibold text-white mb-2">Secure Payment & Access:</p>
                    <ul className="list-disc list-inside space-y-1 text-sm">
                      <li>Industry-standard encryption for secure transactions</li>
                      <li>Multiple payment options (credit cards, digital wallets, international methods)</li>
                      <li>Instant access to purchased courses after payment</li>
                      <li>Flexible subscription plans (monthly/annual)</li>
                      <li>Multi-currency support for international learners</li>
                    </ul>
                  </div>
                </div>
              )
            },
            {
              title: 'Our Values',
              content: (
                <ul className="list-disc list-inside space-y-2 text-gray-300">
                  <li><span className="font-semibold text-white">Excellence:</span> Commitment to delivering the highest quality English learning content and user experience.</li>
                  <li><span className="font-semibold text-white">Innovation:</span> Continuously evolving our platform with the latest language learning technologies.</li>
                  <li><span className="font-semibold text-white">Accessibility:</span> Making English education available to learners regardless of location or background.</li>
                  <li><span className="font-semibold text-white">Trust:</span> Building reliable payment systems and transparent business practices.</li>
                  <li><span className="font-semibold text-white">Community:</span> Creating a supportive environment for English learners worldwide.</li>
                </ul>
              )
            },
            {
              title: 'Our Story',
              content: (
                <p className="text-gray-300">
                  Bristu was founded with a vision to break down language barriers and connect people through English proficiency. Our team of language experts, educators, and technology specialists came together to create a platform that not only teaches English effectively but also provides a seamless payment experience for accessing premium learning content.
                </p>
              )
            },
            {
              title: 'Technology & Features',
              content: (
                <ul className="list-disc list-inside space-y-2 text-gray-300">
                  <li><span className="font-semibold text-white">AI-Powered Assessment:</span> Intelligent algorithms that evaluate your English skills and recommend personalized learning paths.</li>
                  <li><span className="font-semibold text-white">Speech Recognition:</span> Advanced technology to improve pronunciation and speaking skills.</li>
                  <li><span className="font-semibold text-white">Mobile-First Design:</span> Optimized for learning English on any device, anywhere, anytime.</li>
                  <li><span className="font-semibold text-white">Real-Time Progress:</span> Instant feedback and progress tracking for continuous improvement.</li>
                  <li><span className="font-semibold text-white">Secure Payment Processing:</span> Reliable payment gateway integration for hassle-free transactions.</li>
                </ul>
              )
            },
            {
              title: 'Our Impact',
              content: (
                <p className="text-gray-300">
                  Since our launch, Bristu has helped thousands of learners improve their English skills and achieve their language goals. From students preparing for international exams to professionals seeking better career opportunities, our platform has become a trusted partner in their English learning journey, supported by secure and convenient payment solutions.
                </p>
              )
            },
            {
              title: 'Join Our Community',
              content: (
                <p className="text-gray-300">
                  Whether you're a beginner starting your English learning journey or an advanced learner looking to perfect your skills, Bristu welcomes you to join our growing community. Start your English learning adventure today with our secure payment system and discover the endless possibilities that await you.
                </p>
              )
            },
            {
              title: 'Get in Touch',
              content: (
                <div className="space-y-4 text-gray-300">
                  <p>
                    Have questions about our English courses or payment options? We'd love to hear from you. Contact us through any of the following channels:
                  </p>
                  <div className="space-y-2">
                    <p><span className="font-semibold text-white">Call us:</span> <a href="tel:9495759782" className="text-blue-400 underline">+91 9495759782</a></p>
                    <p><span className="font-semibold text-white">Chat to us:</span> <a href="mailto:bristuappofficial@gmail.com" className="text-blue-400 underline">bristuappofficial@gmail.com</a></p>
                  </div>
                  <p>
                    Reach out through our social media channels for support with both learning and payment-related inquiries.
                  </p>
                </div>
              )
            }
          ].map((section, index) => (
            <div key={index} className="bg-gray-900 rounded-2xl p-6 shadow-md space-y-3">
              <h2 className="text-2xl font-bold text-white">{section.title}</h2>
              <div>{section.content}</div>
            </div>
          ))}
        </section>
      </div>
    </div>
  )
}
